import {ShopperLogin} from 'commerce-sdk-isomorphic'
import {isEmpty} from './objectUtils'

export const formattedDate = (date) => {
    if (date) {
        return new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: '2-digit',
            year: 'numeric'
        }).format(new Date(date))
    }
}

export const isProfileComplete = ({firstName, lastName}) => {
    const hasValue = (entity) => {
        if (!entity || typeof entity !== 'string') {
            return false
        }
        return entity?.trim() !== ''
    }
    return hasValue(firstName) && hasValue(lastName)
}

export const todayEndOfDay = () => {
    const today = new Date()
    const year = today.getUTCFullYear()
    const month = String(today.getUTCMonth() + 1).padStart(2, '0')
    const day = String(today.getUTCDate()).padStart(2, '0')
    return `${year}-${month}-${day}T23:59:59Z`
}

export const isTokenExpired = (exp, iat) => {
    const validTimeSeconds = exp - iat - 120 // Instead of treating the token as valid for 30 minutes, it treats it as valid for only 28 minutes.
    const tokenAgeSeconds = Date.now() / 1000 - iat // This calculates how old the token currently is
    return validTimeSeconds <= tokenAgeSeconds
}

export const decodeJWTToken = (token) => {
    if (!token) return null

    try {
        const payload = JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString('utf8'))
        return payload
    } catch (err) {
        return null
    }
}

export const getValidToken = async (appConfig, headersReq) => {
    let finalAuthToken = headersReq.authorization
    try {
        let parsedToken = decodeJWTToken(finalAuthToken)
        console.warn(
            'TokenDetails :' +
                JSON.stringify({
                    basketId: headersReq.basketid,
                    tokendetails: parsedToken.isb,
                    correlationId:
                        headersReq['correlation-id'] || headersReq['x-correlation-id'] || null
                })
        )
        if (parsedToken) {
            let result = isTokenExpired(parsedToken.exp, parsedToken.iat)
            if (!isEmpty(result) && result) {
                const shopperLogin = new ShopperLogin({
                    ...appConfig.commerceAPI,
                    headers: {
                        Authorization: `Basic ${Buffer.from(
                            `${process.env.CLIENT_ID}:${process.env.PWA_KIT_SLAS_CLIENT_SECRET}`
                        ).toString('base64')}`
                    }
                })
                const isbParts = parsedToken.isb.split('::')
                const isGuest = isbParts[1] === 'upn:Guest'
                const usid = parsedToken.sub.split('::')[3].replace('usid:', '')
                let body = {
                    channel_id: appConfig.commerceAPI.parameters.siteId,
                    grant_type: 'client_credentials',
                    login_id: isGuest ? 'guest' : isbParts[1].replace('upn:', ''),
                    idp_origin: 'ecom',
                    hint: 'ts_ext_on_behalf_of',
                    usid: usid
                }
                let response = await shopperLogin.getTrustedSystemAccessToken({
                    body: new URLSearchParams(body)
                })
                if (headersReq.customerid === response.customer_id) {
                    finalAuthToken = `Bearer ${response.access_token}`
                }
            }
        }
    } catch (error) {
        console.error(`Error while refresh token : ${error.message}`)
    }
    return finalAuthToken
}
